import React from "react";

export default function RoleButton({ type, role, text, setRole }) {
  const planButtonSyle = () => {
    const active = type === role ? " active" : "";
    return `button-flat-color pt-feedback ${active}`;
  };

  return (
    <button
      type="button"
      className={planButtonSyle()}
      onClick={() => {
        if (type !== role) setRole(type);
      }}
    >
      {text}
    </button>
  );
}
